import cx from 'classnames'
import type { CSSProperties } from 'react'

import { styles } from './image.styles'

import { ImageAspectRatio, ImageProps } from './image.types'

type PortraitAspectRatio = '1/1' | '3/4' | '9/16'

const portraitMap: Record<ImageAspectRatio, PortraitAspectRatio> = {
  '1/1': '1/1',
  '4/3': '3/4',
  '16/9': '9/16',
}

export function Image({
  src,
  alt,
  objectFit = 'cover',
  aspectRatio = '4/3',
  portrait = false,
  borderRadius = 'none',
  className = '',
  ...imgProps
}: ImageProps) {
  const resolvedAspectRatio = portrait ? portraitMap[aspectRatio] : aspectRatio
  const imageStyle: CSSProperties = {
    ...styles.dynamic(resolvedAspectRatio, objectFit, borderRadius),
    ...imgProps.style,
  }

  return (
    <img
      src={src}
      alt={alt}
      className={cx(styles.base, className)}
      style={imageStyle}
      {...imgProps}
    />
  )
}
